import * as calendar from '../calendar'
import { evnMap } from '../evn'
import { serviceOptionsMap } from '../options'
import { locales } from '../calendar'

const validatePassword = (password) => {
  // Mindestens 8, höchstens 32 Zeichen. Muss einen Buchstaben, sowie eine Ziffer oder eines der folgenden Sonderzeichen enthalten: # ( ) [ ] { } ? ! $ % & / = * + ~ , . : < > @ € - _
  /* eslint-disable-next-line no-useless-escape */
  const validChars = /^[A-Za-z\d#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_\§\^]{8,32}$/g.test(password)
  const hasNumbers = /[0-9]/.test(password)
  const hasAlpha = /[A-Za-z]/.test(password)
  /* eslint-disable-next-line no-useless-escape */
  const hasSpecial = /[#\\\/\?\!\$\%\&\=\[\]\(\)\{\}\*\+\,\.\:\<\>\@\€\-\_]/.test(password)
  return validChars && (hasNumbers || hasSpecial) && hasAlpha
}

const validateVoucher = (voucher) => {
  return /^[0-9]{15,16}$/.test(voucher)
}

const formatterOptions = {
  topUpCurrencyFormatOptions: { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 }
}
const formatter = {
  topUpCurrencyFormatter: Intl.NumberFormat(locales, formatterOptions.topUpCurrencyFormatOptions)
}

const install = function (Vue, options = {}) {
  const $config = {
    brand: 'fyve',
    calendar,
    evnMap,
    serviceOptionsMap,
    formatter,
    validation: {
      validatePassword,
      validateVoucher
    },
    ...options
  }

  Vue.mixin({
    computed: {
      $config () {
        return $config
      }
    }
  })
}

export default {
  install
}
